export default __webpack_public_path__ + "static/antenne-21d976014e6095d3237ef2aeb1c9958c.svg";